var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.455 5C4.055 5 2 6.645 2 8.817v9.543c0 2.172 2.055 3.817 4.455 3.817h2.744l1.75 6.908a.636.636 0 0 0 1.193 0l4.296-6.908h9.108c2.4 0 4.454-1.645 4.454-3.817V8.817C30 6.645 27.945 5 25.546 5H6.454Zm0 1.272h19.09c1.831 0 3.182 1.193 3.182 2.545v9.543c0 1.352-1.35 2.545-3.181 2.545H16a.637.637 0 0 0-.597.407l-3.54 6.084-1.63-6.084a.636.636 0 0 0-.597-.407H6.455c-1.831 0-3.182-1.193-3.182-2.545V8.817c0-1.352 1.35-2.545 3.182-2.545Zm2.167 4.454a.637.637 0 1 0 .06 1.272h14.636a.635.635 0 1 0 0-1.272H8.682a.594.594 0 0 0-.06 0Zm0 4.771a.637.637 0 1 0 .06 1.272h14.636a.637.637 0 1 0 0-1.272H8.682a.594.594 0 0 0-.06 0Z",
    fill: "#6A2BE1"
  })));
};
var Memo = /*#__PURE__*/memo(SvgChat);
export default Memo;